import { render, staticRenderFns } from "./TicketsList.vue?vue&type=template&id=61704aa8"
import script from "./TicketsList.vue?vue&type=script&lang=ts"
export * from "./TicketsList.vue?vue&type=script&lang=ts"
import style0 from "./TicketsList.vue?vue&type=style&index=0&id=61704aa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports